import * as React from 'react';

import * as styles from './SearchTipsContainer.css';
import { SearchTip } from '../../components/SearchTips/SearchTip';
import { IFullTipSchema } from '../../repositories/text-search/entities/tips/FullTipSchema';
import classNames from 'classnames';
import { Responsive } from '@cian/ui-kit';

interface ISearchTipsContainerProps {
  tips?: IFullTipSchema[];
  desktopStyle?: boolean;
  isMainPageTips?: boolean;
  isTipsDisabled?: boolean;
  onClick: (tips: IFullTipSchema) => void;
}

export const SearchTipsContainer: React.FC<ISearchTipsContainerProps> = ({
  tips,
  desktopStyle = false,
  isMainPageTips = false,
  isTipsDisabled = false,
  onClick,
}) => {
  return (
    <div>
      <Responsive desktop>
        <div
          className={classNames(
            styles['gallery-container'],
            isMainPageTips && styles['main-page-style'],
            desktopStyle && styles['desktop-style'],
          )}
        >
          {tips &&
            tips?.length > 0 &&
            tips.map((tip, index) => (
              <SearchTip key={index} tip={tip} onClick={onClick} isTipsDisabled={isTipsDisabled} />
            ))}
        </div>
      </Responsive>

      <Responsive phone tablet>
        <div className={classNames(styles['wrap-container'], desktopStyle && styles['desktop-style'])}>
          {tips &&
            tips?.length > 0 &&
            tips.map((tip, index) => (
              <SearchTip key={index} tip={tip} onClick={onClick} isTipsDisabled={isTipsDisabled} />
            ))}
        </div>
      </Responsive>
    </div>
  );
};
